import styled from 'styled-components';

export const Content = styled.div`
    display: block;
    box-sizing: border-box;
    max-width: 1600px;
    margin: 0 auto;
`;
